import React, {  useState } from "react"
import { Dropdown, DropdownToggle, DropdownMenu, Row, Col } from "reactstrap"



const NotificationDropdown = props => {
  const user = JSON.parse(localStorage.getItem("user"));
  const groups =String(user.groups);

  // Declare a new state variable, which we'll call "menu"
  const [menu, setMenu] = useState(false)

/*  useEffect(() => {
    getUserPorVincular();
  },[]);
  const [users, setUsers] = useState({})

  const getUserPorVincular = async () => {
    const response = await getUsersPorVincular();
    const data = response.data;
    setUsers(data)
  };*/
  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="dropdown d-inline-block"
        tag="li"
      >
        <DropdownToggle
          className="btn header-item noti-icon"
          tag="button"
          id="page-header-notifications-dropdown"
        >
          <i className="mdi mdi-bell" />
      {/*   {groups.includes("SuperAdmin") ||  groups.includes("Supervisor") ? (
            Array.isArray(users) ? 
              users.length !== 0 ? (
          <span className="badge bg-danger rounded-pill"> {users.length} </span>
              ):null
            :[]
          ):null}
              */}
        </DropdownToggle>

        <DropdownMenu className="dropdown-menu dropdown-menu-lg p-0 dropdown-menu-end">
          <div className="p-3">
            <Row className="align-items-center">
              <Col>
                <h6 className="m-0">Notificaciones</h6>
              </Col>
              {groups.includes("SuperAdmin") ||  groups.includes("Supervisor") ? (
              <div className="col-auto">
                <a href="users/user_por_vincular" className="small">
                  Ver todas
                </a>
              </div>
              ):null}
            </Row>
          </div>
 {/*{groups.includes("SuperAdmin") ||  groups.includes("Supervisor") ? (
          Array.isArray(users) ? users.map( (user, idx) => (
          <SimpleBar key={idx} style={{ height: "auto" }}>
            <Link to={`/vinculacion/${user.codigo_vinculacion}` }className="text-reset notification-item d-block">
              <div className="d-flex">
                <div className="avatar-xs me-3">
                  <span className="avatar-title bg-danger rounded-circle font-size-16">
                    <i className=" fas fa-user-clock " />
                  </span>
                </div>
                <div className="flex-1">
                  <h6 className="mt-0 mb-1">
                    Notificación {idx}
                  </h6>
                  <div className="font-size-12 text-muted">
                    <p className="mb-1">
                      El Usuario {user.username} está solicitando vinculación
                    </p>
                    <p className="mb-0">
                      <i className="mdi mdi-clock-outline" />{" "}
                      Hace 3 min
                    </p>
                  </div>
                </div>
              </div>
            </Link>
          </SimpleBar>
          )):[]
          ):null}*/}
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  )
}

export default NotificationDropdown
